export const colors = {
  lighterPrimary: {
    default: '#F8FAFC',
    contrast: '#313638',
  },

  lightPrimary: {
    default: '#F2F2F2',
    contrast: '#313638',
  },

  primary: {
    default: '#005950',
    contrast: '#FFFFFF',
  },

  darkPrimary: {
    default: '#005950',
    contrast: '#FFFFFF',
  },
  white: {
    default: '#ffffff',
    contrast: '#006954',
  },

  red: {
    default: '#E30613',
    contrast: '#FFFFFF',
  },

  midPrimary: {
    default: '#009CDE',
    contrast: '#FFFFFF',
  },

  lightGreen: {
    default: '#B8CCA4',
    contrast: '#FFFFFF',
  },

  lightGreen10: {
    default: '#0069541a',
    contrast: '#FFFFFF',
  },

  green: {
    default: '#B2E76A',
    contrast: '#006954',
  },

  darkGreen: {
    default: '#8dd553',
    contrast: '#FFFFFF',
  },

  darkGreenHover: {
    default: '#005443',
    contrast: '#FFFFFF',
  },

  pink: {
    default: '#E68699',
    contrast: '#FFFFFF',
  },

  orange: {
    default: '#C4541D',
    contrast: '#FFFFFF',
  },

  yellow: {
    default: '#F2A900',
    contrast: '#FFFFFF',
  },

  grey: {
    default: '#fff',
    contrast: '#313638',
  },

  lightGrey: {
    default: '#F4F6F5',
    contrast: '#FFFFFF',
  },

  transparent: {
    default: 'transparent',
    contrast: 'transparent',
  },
};

export default colors;

export type ThemeColors = typeof colors;
export type ThemeColorsKeys = keyof typeof colors;
